<app-week-registration-dialog-shell
  [data]="data"
  (alt)="saveAndNextWeek()"
  (dialogClose)="cancel()"
  (confirm)="save()"
>
  <div summary class="spacing--margin-horizontal breeder-summary">
    <div class="spacing--margin-bottom">
      <div class="breeder-summary__grid">
        <div class="flex--column breeder-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.period' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ firstDayOfWeek() | agrDate }} -<br />{{ lastDayOfWeek() | agrDate }}
          </span>
        </div>

        @if (amountOfHensStartOfWeekValue() !== undefined) {
          <div class="flex--column breeder-summary__item">
            <span class="text--small text--gray label">
              {{ 'week-registration.amountOfHensStartOfWeek' | translate }}
              {{ currentWeekRegistrationValue().weekNr }}
            </span>
            <span class="text--small text--bold label">
              {{ amountOfHensStartOfWeekValue() }}
            </span>
          </div>
        }

        @if (hasRoosters()) {
          <div class="flex--column breeder-summary__item">
            <span class="text--small text--gray label">
              {{ 'week-registration.amountOfRoostersStartOfWeek' | translate }}
              {{ currentWeekRegistrationValue().weekNr }}
            </span>
            <span class="text--small text--bold label">
              {{ amountOfRoostersStartOfWeekValue() }}
            </span>
          </div>
        }

        <div class="flex--column breeder-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.amountOfHensStartOfFlock' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.amountOfHens }}
          </span>
        </div>

        @if (hasRoosters()) {
          <div class="flex--column breeder-summary__item">
            <span class="text--small text--gray label">
              {{ 'week-registration.amountOfRoostersStartOfFlock' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ data.flock.arrival.amountOfRoosters }}
            </span>
          </div>
        }

        <div class="flex--column breeder-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.breed' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.breed?.name }}
          </span>
        </div>

        <div class="flex--column breeder-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.barn' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.barn?.name }}
          </span>
        </div>

        <div class="flex--column breeder-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.dateOfBirth' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.chickBirthDate | agrDate }}
          </span>
        </div>

        <div class="flex--column breeder-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.arrivalDate' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.arrivalDate | agrDate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  @if (hasFormGroups()) {
    <div content class="flex--row breeder-content">
      @if (!isWeeklyInputMethod()) {
        @if (hasSeparateWeeklySection() && separateWeeklyFormGroup(); as weeklyFormGroup) {
          <section class="breeder-weekly-section">
            <div class="breeder-weekly-section__header">
              {{ 'week-registration.weekly-registrations' | translate }}
            </div>
            <app-breeder-week-registration-form
              data-test="breeder-week-registration__weeklySection"
              class="flex__child--auto"
              [formGroup]="weeklyFormGroup"
              [showFields]="allWeeklyShowFields()"
              [index]="-1"
            />
          </section>
        }

        <mat-tab-group
          [mat-stretch-tabs]="false"
          animationDuration="0"
          [selectedIndex]="selectedTabIndexValue()"
          (selectedIndexChange)="onSelectedTabIndexChange($event)"
          color="accent"
          class="weekRegistrationTabs"
        >
          @for (tab of tabsValue(); track tab.name; let i = $index) {
            <mat-tab [label]="tab.name" class="week-registration-tab">
              <app-breeder-week-registration-form
                data-test="breeder-week-registration__dailyView"
                class="flex__child--auto"
                [formGroup]="dailyFormGroups()[i]"
                [showFields]="tab.showFields"
                [index]="i"
                (mortalityChanged)="mortalityForDayChanged($event)"
              />
            </mat-tab>
          }
        </mat-tab-group>
      } @else {
        @for (formGroup of weeklyFormGroups(); track formGroup) {
          <app-breeder-week-registration-form
            data-test="breeder-week-registration__weeklyView"
            class="flex__child--auto"
            [formGroup]="formGroup"
            [showFields]="allWeeklyShowFields()"
            [index]="0"
            (mortalityChanged)="mortalityForDayChanged($event)"
          />
        }
      }
    </div>
  }
</app-week-registration-dialog-shell>
